
import React, { useState, useEffect } from 'react';
import './CountDown.css'; // Import the CSS file

import EmployeeCountDown from "../components/EmployeeCountDown";

const Countdown = () => {
  // Days timer countdown
  const targetDate = new Date('2025-10-01T23:59:59'); // Set your target date here
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const now = new Date();
    const difference = targetDate - now;

    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 }; // Timer ended
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, []);

  // Employee Count down
  const counters = [
    { label: "Employees", start: 300, end: 250 },
    { label: "Clients", start: 100, end: 60 },
    { label: "Years of Experience", start: 25, end: 20 },
  ];

  const [counts, setCounts] = useState(
    counters.map((counter) => counter.start)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCounts((prevCounts) =>
        prevCounts.map((count, index) =>
          count > counters[index].end ? count - 1 : count
        )
      );
    }, 50); // Speed of countdown

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container mt-6">
      <div className="row">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header">
              <h3>Days Countdown Timer</h3>
            </div>
            <div className="card-block">
              <div className="countdown-container">
                <div className="countdown-display">
                  <div className="time-block">
                    <span>{timeLeft.days}</span>
                    <span className="text-primary">Days</span>
                  </div>
                  <div className="time-block">
                    <span>{timeLeft.hours}</span>
                    <span className="text-primary">Hours</span>
                  </div>
                  <div className="time-block">
                    <span>{timeLeft.minutes}</span>
                    <span className="text-primary">Minutes</span>
                  </div>
                  <div className="time-block">
                    <span>{timeLeft.seconds}</span>
                    <span className="text-primary">Seconds</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header">
              <h3>Employee Countdown Timer</h3>
            </div>
            <div className="card-block">
              <EmployeeCountDown />
            </div>
          </div>
        </div>
      </div>  
    </div>
  );
};

export default Countdown;